import { HTMLAttributes } from 'react';
import { ControllerRenderProps } from 'react-hook-form';

import { MultiSelector } from '../../../multi-selector/multi-selector';
import { DATA_TYPE } from '../../constants/data-type';
import { Attribute } from '../attribute';
import { FieldWrapper } from '../field-wrapper';
import { castingArrayNumber } from '../utils/casting-array-number';
import { modelToOptions } from '../utils/model-to-options';

interface MultiSelectorRenderProps extends Pick<HTMLAttributes<HTMLDivElement>, 'className'> {
  attribute: Attribute;
  field: ControllerRenderProps<any>;
  isLoading?: boolean;
}

export function MultiSelectorRender({
  attribute,
  className,
  field,
  isLoading,
}: MultiSelectorRenderProps) {
  const {
    dataType,
    disabled,
    id,
    model,
    multiSelectorCreatable,
    multiSelectorMaxSelected,
    placeholder,
    renderModelItem,
  } = attribute;
  const { value, onChange, disabled: _disabled, ...rest } = field;

  return (
    <FieldWrapper className={className} {...attribute}>
      <MultiSelector
        {...rest}
        disabled={disabled}
        isLoadingSx={isLoading}
        creatable={multiSelectorCreatable === undefined ? true : multiSelectorCreatable}
        emptyIndicator={
          <p className="py-4 text-center text-sm">
            {multiSelectorCreatable === false
              ? 'Creación de elementos deshabilitada'
              : 'Escribe el valor y presiona enter'}
          </p>
        }
        inputProps={{
          id,
          maxLength: 250,
        }}
        maxSelected={multiSelectorMaxSelected}
        options={modelToOptions({ model })}
        renderOption={
          renderModelItem
            ? (option) => renderModelItem({ value: option.value, item: option.label })
            : undefined
        }
        placeholder={placeholder}
        value={value}
        onChange={(options) => {
          if (dataType === DATA_TYPE.arrayNumber || dataType === DATA_TYPE.number) {
            onChange(castingArrayNumber(options));
          } else {
            onChange(options);
          }
        }}
      />
    </FieldWrapper>
  );
}
